import { gsap, ScrollTrigger, clickNav, fadeUpOnScroll } from '../layout';
import Modal from 'bootstrap/js/dist/modal';

document.addEventListener("DOMContentLoaded", function(){
	clickNav();
	fadeUpOnScroll();

	// open thank tou modal
	const modalSuccess = new Modal(document.getElementById('modalSuccess'));
	const modalMarketing = new Modal(document.getElementById('modalMarketing'));
	var closeButton = document.querySelector('.modal-marketing .btn-close');
	document.addEventListener('wpcf7submit', function(event) {
		if (event.detail.status === 'mail_sent') {
			closeButton.click();
			setTimeout(() => {
				modalSuccess.show();
			}, 500);
			setTimeout(() => {
				modalSuccess.hide();
			}, 5000);
		}
	}, false);
});